import * as actionTypes from "../../actions/actionTypes";
import {updateObject} from "../../shared/utility";

export interface IProject {
  projectId: number,
  projectAlias: string,
  projectName: string,
  projectDescription: string,
  tagCloud: Record<string, unknown>,
  deleted: boolean,
  active: boolean,
  createdAt: string,
  updatedAt: string,
  backgroundStimulusId: number,
  iconStimulusId: number,
  departmentId: number,
  projectOwnerId: number,
  cascadedProjectId: number,
  createdBy: number,
  updatedBy: number,
  cascadedProjectOrder: number,
  reels: boolean,
}

interface IInitialState {
  projects: IProject[],
  loading: boolean,
  experienceAddedMsg: string,
  isExperienceAdded: boolean
}

const initialState: IInitialState = {
  projects: [],
  loading: false,
  experienceAddedMsg: '',
  isExperienceAdded: false
};

const reducer = (state = {...initialState}, action: any) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return updateObject(state, {
        loading: action.payload
      });

    case actionTypes.UPDATE_PROJECTS:
    case actionTypes.GET_PROJECTS_SUCCESS:
      return updateObject(state, {
        projects: action.payload
      });

    case actionTypes.ADD_PROJECT_SUCCESS:
      const projects = [...state.projects];
      projects.push(action.payload);
      return updateObject(state, {
        projects
      });

    case actionTypes.UPDATE_PROJECT_SUCCESS:
      const currentProjects = [...state.projects];
      currentProjects[action.payload.index] = action.payload.project;
      return updateObject(state, {
        projects: currentProjects
      });

    case actionTypes.DELETE_PROJECT_SUCCESS:
      const projectList = [...state.projects];
      const index = action.payload;
      projectList.splice(index, 1);
      return updateObject(state, {
        projects: [...projectList]
      });

    case actionTypes.ADD_PROJECT_TO_EXPERIENCE_SUCCESS:
      const status = action.payload['status'];
      const message = action.payload['message'];
      return updateObject(state, {
        experienceAddedMsg: message,
        isExperienceAdded: status
      });

    case actionTypes.INIT_ALERT_STATUS:
      return updateObject(state, {
        experienceAddedMsg: '',
        isExperienceAdded: false
      });

    default:
      return state;
  }
};

export default reducer;